module.exports = __webpack_public_path__ + "img/logo.d46d6bda.svg";